export default __webpack_public_path__ + "static/media/cancel.5bec4f69.svg";